export default "__VITE_ASSET__DH9wSEXH__"